// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { PageHeader } from "#/features/global-ui/page-header"
import { PageLayout } from "#/features/global-ui/page-layout"
import { BookingForm } from "#/features/telemedicine/booking/BookingForm"
import { Title } from "#/services/page-title/Title"
import { Paths } from "#/utils/Paths"
import { Typography } from "@carrotfertility/carotene-core"
import { useFlags } from "launchdarkly-react-client-sdk"
import React from "react"
import { Redirect } from "react-router-dom"

export function TelemedicineBookingPage() {
  const { telemedicineBookingFlow } = useFlags()

  if (!telemedicineBookingFlow) {
    return <Redirect to={Paths.HOME} />
  }

  return (
    <PageLayout variant="default" header={<PageHeader pageTitle="Telemedicine Booking" />}>
      <Title title="Telemedicine Booking" />
      <Typography>Carrot Clinic</Typography>
      <BookingForm />
    </PageLayout>
  )
}
